import React from "react";

export default function DashboardControls({ live, onToggleLive, range, onChangeRange, rangeOptions = [], source = "api", lastUpdated }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 18 }}>
      <div>
        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.58)", marginBottom: 6 }}>Real-time overview</div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(139,255,176,0.10)", color: "#8bffb0", border: "1px solid rgba(139,255,176,0.20)", borderRadius: 999, padding: "6px 12px", fontSize: 12, fontWeight: 800 }}>
            <span style={{ width: 8, height: 8, borderRadius: 99, background: "#8bffb0", boxShadow: "0 0 12px rgba(139,255,176,0.85)" }} />
            {live ? "Live updates on" : "Live updates paused"}
          </span>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.05)", color: "#fff", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 999, padding: "6px 12px", fontSize: 12, fontWeight: 700 }}>
            Source: {source}
          </span>
          {lastUpdated && (
            <span style={{ color: "rgba(255,255,255,0.62)", fontSize: 12 }}>
              Last refresh {lastUpdated}
            </span>
          )}
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10 }}>
        <div style={{ display: "flex", background: "#1c250e", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 999, padding: 4 }}>
          {rangeOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChangeRange(option.value)}
              style={{
                border: "none",
                cursor: "pointer",
                color: range === option.value ? "#080a05" : "#fff",
                background: range === option.value ? "#8bffb0" : "transparent",
                fontWeight: 800,
                fontSize: 12,
                padding: "10px 14px",
                borderRadius: 999,
                transition: "all 160ms ease",
              }}
            >
              {option.label}
            </button>
          ))}
        </div>

        <button
          type="button"
          onClick={onToggleLive}
          style={{
            border: "1px solid rgba(255,255,255,0.10)",
            background: live ? "rgba(139,255,176,0.16)" : "rgba(255,255,255,0.06)",
            color: live ? "#8bffb0" : "#fff",
            borderRadius: 14,
            padding: "10px 16px",
            fontWeight: 800,
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          {live ? "Pause updates" : "Resume live"}
        </button>
      </div>
    </div>
  );
}
